import Headroom from '../../webpack/node_modules/headroom.js'

export default () => {
  const navMain = document.getElementById('js-main-nav')
  const isPinned = 'g-navigation-is-pinned'
  if (navMain) {
    const headroom = new Headroom(navMain, {
      offset: 10,
      tolerance: 5,
      classes: {
        pinned: 'main-nav--pinned',
        unpinned: 'main-nav--unpinned',
      },
      onPin () {
        document.documentElement.classList.add(isPinned)
      },
      onUnpin () {
        document.documentElement.classList.remove(isPinned)
      },
      onNotTop () {
        document.documentElement.classList.remove(isPinned)
      },
    })

    headroom.init()

    return headroom
  }
};
